import { action } from 'mobx';
import decorator from 'lib/lang/decorator';

export default decorator(() => Class => {
    class UserMentionable extends Class {
        @action mention({ username }: { username: string }) {
            let { value = '' } = this.userMentionableField.data;

            if (value && !value.endsWith(' ')) {
                value += ' ';
            }

            this.userMentionableField.data.setValue({
                value: `${value}@${username} `,
            });
        }
    }

    return UserMentionable;
});
